import { html, LitElement } from 'lit-element';
import { getPercentage } from '../headerBlocks/utils.js';
import { processEscapedMarkup } from '../../utils.js';

/**
 * @element view-details-modal-ecr
 * @prop {Object} response - Response
 * IMPORTANT: ONLY DISPLAYED FOR CORRECT RESPONSE
 */
export class ViewDetailsModalECR extends LitElement {
  static get properties() {
    return {
      response: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { studentsNr, studentsAnsweredNr = 1, item } = this.response || {};
    const { markup, choices } = item || {};

    const percentage = getPercentage(studentsNr, studentsAnsweredNr);

    if (!markup || !choices) return '';

    let a = 0;

    const text = processEscapedMarkup(markup);
    const value = text.replace(/\{\{[^}]*\}\}/g, () => {
      if (choices[a] && choices[a][0]) {
        a += 1;
        // eslint-disable-next-line no-plusplus
        return choices[a - 1][0].label;
      }

      return '';
    });

    return html`<div>
      <div class="modal-response-content">
        <div class="modal-response-content-row">
          <math-rendering-element .label=${value}></math-rendering-element>
        </div>
      </div>

      <div class="header-students-number">
        ${studentsNr} Student${studentsNr === 1 ? '' : 's'} (${percentage}%)
      </div>
    </div>`;
  }
}

export default ViewDetailsModalECR;
